module.exports = __webpack_public_path__ + "img/access_1.0269605c.jpg";